import { VehicleCategory } from '@navio/nsdk';
import { type IconSizeValue, NoddiIcon } from 'noddi-ui-common';
import { usesPassengerVehicleIllustration } from 'noddi-util';
import { ReactNode } from 'react';
import { VEHICLE_CATEGORY_ICON } from './vehicleCategoryIcons';

type Props = {
  vehicleCategory?: VehicleCategory;
  size?: IconSizeValue;
  passengerFallback?: ReactNode;
};

export const VehicleCategoryIcon = ({ vehicleCategory, size = 'large', passengerFallback }: Props) => {
  const category = vehicleCategory ?? VehicleCategory.PASSENGER;

  if (passengerFallback && usesPassengerVehicleIllustration(category)) {
    return passengerFallback;
  }

  return <NoddiIcon name={VEHICLE_CATEGORY_ICON[category]} size={size} />;
};
